<template>
  <div
    v-if="searchedItems?.length > 0"
    ref="kkSearchmodalSearch"
    v-outside-click="clickOutside"
    class="kk_searchmodal-search"
    :style="styles"
    data-test-id="smart-search-dropdown"
  >
    <div class="kk_searchmodal-search--up" @click="moveItemsDown" @mouseenter="moveItemsDown">
      <i class="icon-menu-up"></i>
    </div>
    <div
      v-for="(item, index) in searchedItems"
      :key="index"
      class="kk_searchmodal-search_item"
      :class="{
        'kk_searchmodal-search_item-active': index === activeIndex,
        'kk_searchmodal-search_item-disabled': !item.show(),
      }"
      :style="{
        ...getActiveItemStyle(item, index),
        ...getItemBorder(item, index),
        marginLeft: !hasChildren ? '2px' : '',
      }"
      @click="click(item)"
      @mouseenter="activeIndex = index"
    >
      <!--This empty i tag is a hack for creating gap -->
      <i></i>
      <i v-if="item.icon" :class="typeof item.icon === 'function' ? item.icon() : item.icon"></i>
      <span
        v-if="!item.icon"
        :style="{ ...item.style, backgroundColor: item.style?.bgColor }"
        class="kk_searchmodal-search_item--style"
      >
        T
      </span>
      <span>{{ item.value }}</span>
      <span>
        {{ item.title }}
      </span>
    </div>
    <div class="kk_searchmodal-search--down" @click="moveItemsUp" @mouseenter="moveItemsUp">
      <i class="icon-menu-down"></i>
    </div>
  </div>
</template>
<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";

export default {
  props: ["searchedItems", "styles", "hasChildren"],
  emits: ["select-formula", "complete-formula"],
  data() {
    return {
      isExpanded: null,
      activeIndex: 0,
      selectedFormula: null,
    };
  },
  computed: {
    prevScope() {
      return this.$store.state.smartSearch.smartSearchPrevScope;
    },
  },
  watch: {
    searchedItems() {
      this.activeIndex = 0;
    },
  },
  mounted() {
    this.$store.dispatch("smartSearch/setSmartSearchPrevScope", hotkeys.getScope());
    this.$store.dispatch("setScope", HotkeyScopes.SmartSearch);

    hotkeys("up", HotkeyScopes.SmartSearch, (event, handler) => {
      event?.preventDefault();
      this.moveUp();
      this.$nextTick(() => {
        this.scroll("start");
      });
    });
    hotkeys("down", HotkeyScopes.SmartSearch, (event, handler) => {
      event?.preventDefault();
      this.moveDown();
      this.$nextTick(() => {
        this.scroll("end");
      });
    });
    hotkeys("Enter", HotkeyScopes.SmartSearch, (event, handler) => {
      event?.preventDefault();
      this.selectedFormula = this.searchedItems[this.activeIndex];
      this.$emit("select-formula", this.selectedFormula);
    });
    hotkeys("tab", HotkeyScopes.SmartSearch, (event, handler) => {
      event?.preventDefault();
      this.selectedFormula = this.searchedItems[this.activeIndex];
      this.$emit("complete-formula", this.selectedFormula);
    });
  },
  beforeUnmount() {
    hotkeys.unbind("up, down, tab, Enter", HotkeyScopes.SmartSearch);
    this.$store.dispatch("setScope", this.prevScope);
  },
  methods: {
    clickOutside() {
      this.$store.dispatch("pdesign/setSmartSearchBoxVisibility", false);
    },
    moveItemsUp() {
      const container = this.$refs.kkSearchmodalSearch;
      container.scrollBy({
        top: 165,
        behavior: "smooth",
      });
    },

    moveItemsDown() {
      const container = this.$refs.kkSearchmodalSearch;
      container.scrollBy({
        top: -165,
        behavior: "smooth",
      });
    },
    getActiveItemStyle(item, index) {
      if (!this.hasChildren && index === this.activeIndex) {
        return {
          backgroundColor: `${item.style?.border}`,
        };
      }
    },
    getItemBorder(item, index) {
      if (!this.hasChildren && index === this.activeIndex) {
        return {
          borderLeft: `5px solid ${item.style?.bg}`,
        };
      } else if (!this.hasChildren) {
        return {
          borderLeft: `5px solid ${item.style?.border}`,
        };
      }
    },
    click(item) {
      this.$emit("select-formula", item);
    },
    moveDown() {
      if (this.activeIndex === this.searchedItems.length - 1) this.activeIndex = 0;
      else this.activeIndex++;
    },
    moveUp() {
      if (this.activeIndex == 0) this.activeIndex = this.searchedItems.length - 1;
      else this.activeIndex--;
    },
    scroll() {
      const activeItem = document.querySelector(".kk_searchmodal-search_item-active");
      if (!activeItem) return;
      activeItem.scrollIntoView({
        behavior: "auto",
        block: "center", // Scroll to bottom of visible area
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
.kk_searchmodal-search {
  color: initial;
  position: absolute;
  top: 110%;
  right: 0;
  left: 0;
  max-height: 15rem;
  overflow: auto;
  background-color: @kk-color-white;
  border: 1px solid @kk-color-light-gray;
  border-radius: @kk-border-radius;
  z-index: 900;
  /* Hide the scrollbar for Internet Explorer, Edge and Firefox */
  -ms-overflow-style: none; /* Internet Explorer and Edge */
  scrollbar-width: none; /* Firefox */

  /* Hide the scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  &--up,
  &--down {
    display: flex;
    justify-content: center;
    font-size: 1.7rem;
    position: sticky;
    z-index: 10;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    background-color: transparent;
  }

  &--up {
    top: 3%;
  }

  &--down {
    bottom: -7%;
  }

  &_item {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    margin-top: 5px;
    padding: 5px 0px;
    color: @kk-color-primary-blue;

    &--style {
      width: 1.9rem;
      padding: 1px 8px;
      border-radius: 2px;
    }

    &-active,
    &:hover {
      background-color: @kk-color-light-blue;
    }
    &-disabled {
      color: rgb(168, 167, 167);
    }
  }
}
</style>
